import React from 'react';
import LinkCard from '../shared-components/link_card';
import LearningAboutLoans from './learning_about_loans';
import SavingMoney from './saving_money';
import InvestmentExtraCredit from './investment_extra_credit';
import InsuranceExtraCredit from './insurance_extra_credit';
import CelebrationModal from '../shared-components/celebration_modal';
import ExtraCreditConfigFile from './Datasets/extra_credit_config_file';
import { doubleToStringMonthly } from '../../objects/CommonUse/double_functions';
import getLinkNames from './objects/get_link_names';

class Level2Challenges extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            callRender: false,
            modalOpen: false,
            celebrationModal: false,
            prevProcess: this.props.prevProcess,
        }  
        this.nextProcess = "";
        this.category1Complete = false;
        this.category2Complete = false;
        this.category3Complete = false;
        this.category4Complete = false;
        this.category1Name = "SavingMoney";
        this.category2Name = "LearningAboutLoans";
        this.category3Name = "Investments";
        this.category4Name = "Insurance";
        this.extraCreditReward = ExtraCreditConfigFile.exercises;
        this.checkCompleted = true;
           
    }

setCompleted(){
    let exerciseInfo = this.props.extraCreditCompleted.find(elem => elem.category === this.category1Name);
    if (exerciseInfo  && exerciseInfo.complete === true){
        this.category1Complete = true;
    }
    exerciseInfo = this.props.extraCreditCompleted.find(elem => elem.category === this.category2Name);
    if (exerciseInfo  && exerciseInfo.complete === true){
        this.category2Complete = true;
    }
    exerciseInfo = this.props.extraCreditCompleted.find(elem => elem.category === this.category3Name);
    if (exerciseInfo  && exerciseInfo.complete === true){
        this.category3Complete = true;
    }
    exerciseInfo = this.props.extraCreditCompleted.find(elem => elem.category === this.category4Name);
    if (exerciseInfo  && exerciseInfo.complete === true){
        this.category4Complete = true;
    }
}

selectNextChallenge(challengeName) {
    this.nextProcess = challengeName;
    this.setState({modalOpen: true});
}

closeModal(){
    this.setState({modalOpen: false});
}

render() {
    const linkNames = getLinkNames("2");
    if (this.nextProcess !== ""){
        sessionStorage.setItem("GameViewSubProcess", this.nextProcess)
    }
    if (this.checkCompleted === true){
        this.setCompleted();
        this.checkCompleted = false;
    }
  
        
return <>
    <div className="col-sm-8 mt-1">
        <div className="card mt-3 rounded-corners-lg h-100 center-large-buttons">
            <button className="pages-back-button ml-4 mt-4" 
                        onClick ={()=> this.props.goBack()}>
                                Back
            </button>
            <h3 className="mt-0 text-center">Level 2 Challenges</h3>
        
        <span>
             <span className="row w-100 ml-4 mx-0">
                                     
                {this.category1Complete ?
                    <span className="col-sm-5 ml-4 mt-0 buttonDisabledImage">
                        <div>
                            <LinkCard name={linkNames[0]} imgSrc='./assets/ExtraCredit/saveMoney.png'
                              alt=""
                        />
                        </div>
                    </span>
                :
                    <span className="col-sm-5 ml-4 mt-0 cursor-is-pointer"
                        onClick={() => this.selectNextChallenge(this.category1Name)}>
                        <div>
                        <LinkCard name={linkNames[0]} imgSrc='./assets/ExtraCredit/saveMoney.png'
                            alt=""
                            />
                        </div>
                    </span>
                }
                {this.category2Complete ?
                    <span className="col-sm-5 ml-4 mt-0 buttonDisabledImage" >
                        <div>
                        <LinkCard name={linkNames[1]} imgSrc='./assets/ExtraCredit/learningAboutLoans.png' 
                            alt=""/>
                            </div>
                    </span>
                :
                    <span className="col-sm-5 ml-4 mt-0 cursor-is-pointer" 
                        onClick={() => this.selectNextChallenge(this.category2Name)}>
                        <div>
                        <LinkCard name={linkNames[1]} imgSrc='./assets/ExtraCredit/learningAboutLoans.png' 
                             alt=""/>
                        </div>
                    </span>
                }
            </span>

        <span className="row w-100 mx-0 ml-4">
            {this.category3Complete ?
                    <span className="col-sm-5 ml-4 my-4 buttonDisabledImage" >
                        <div>
                        <LinkCard name={linkNames[2]} imgSrc='./assets/ExtraCredit/investments.png' 
                             alt=""/>
                            </div>
                    </span>
                :
                    <span className="col-sm-5 ml-4 my-4 cursor-is-pointer" 
                        onClick={() => this.selectNextChallenge(this.category3Name)}>
                        <div>
                        <LinkCard name={linkNames[2]} imgSrc='./assets/ExtraCredit/investments.png' 
                             alt=""/>
                        </div>
                    </span>
                }
                 {this.category4Complete ?
                    <span className="col-sm-5 ml-4 mt-0 my-4 buttonDisabledImage" >
                        <div>
                        <LinkCard name={linkNames[3]} imgSrc='./assets/ExtraCredit/insurance.png' 
                           alt=""/>
                            </div>
                    </span>
                :
                    <span className="col-sm-5 ml-4 my-4 cursor-is-pointer" 
                        onClick={() => this.selectNextChallenge(this.category4Name)}>
                        <div>
                        <LinkCard name={linkNames[3]} imgSrc='./assets/ExtraCredit/insurance.png' 
                             alt=""/>
                        </div>
                    </span>
                }
        </span>
    </span>
    
        {this.nextProcess === this.category1Name ?
            <SavingMoney
                show={this.state.modalOpen}
                onCompleted={() => this.challengeCompleted(this.category1Name)}
                onClose={() => this.closeModal()}
            /> 
        :
            <div></div>
        }
        {this.nextProcess === this.category2Name ?
            <LearningAboutLoans 
                show={this.state.modalOpen}
                onCompleted={() => this.challengeCompleted(this.category2Name)}
                onClose={() => this.closeModal()}
            /> 
        :
            <div></div>
        }

        {this.nextProcess === this.category3Name ?
            <InvestmentExtraCredit
                show={this.state.modalOpen}
                onCompleted={() => this.challengeCompleted(this.category3Name)}
                onClose={() => this.closeModal()}
            /> 
        :
            <div></div>
        }

        
        {this.nextProcess === this.category4Name ?
            <InsuranceExtraCredit
                show={this.state.modalOpen}
                onCompleted={() => this.challengeCompleted(this.category4Name)}
                onClose={() => this.closeModal()}
            /> 
        :
            <div></div>
        }
    
        {this.nextProcess === "CelebrationModal"  ?
            <CelebrationModal
                isOpen={this.state.celebrationModal}
                onClose={() => this.closeCelebrationModal()}                        
                type={"extraCredit"}
                title={this.extraCreditTitle}
                description={this.additionalText}
                imgSrc={this.imgSrc}
                trophyID={""}
            />
        :
            null
        }
    
    </div>
       
    </div>   
</>
  }
  
challengeCompleted(processName) {
    this.props.updateAmounts();
    const exerciseInfo = this.extraCreditReward.find(elem => elem.category === processName);
    this.checkCompleted = true;
    let typeLit = "";
    if (exerciseInfo.type === "salary"){
            typeLit = "monthly salary";
    }else{
            typeLit = "current cash";
    }
    this.imgSrc = "./assets/ExtraCredit/" + exerciseInfo.imgSrc;
    this.nextProcess = "CelebrationModal"
    this.extraCreditTitle = exerciseInfo.titleText + " Challenges Completed";
    this.additionalText = "Congratulations!  Your " + typeLit + " has been increased by " +
            doubleToStringMonthly(exerciseInfo.amt) + ".";
    this.setState({celebrationModal: true, modalOpen: false});
}


closeCelebrationModal(){
    this.setState({celebrationModal: false});
}



}

export default Level2Challenges;